import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d138fb78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "I CAR")
], -1))
const _hoisted_3 = { class: "navigation-sections" }
const _hoisted_4 = {
  key: 0,
  class: "navigation-footer"
}

import { computed, ref, Ref } from 'vue';
import {
  NAVIGATION_TYPES,
  NavigationButton,
  NavigationNode as NavigationNodeType,
  NavigationNodeRender,
} from './types';
import NavigationNode from './NavigationNode.vue';
import { useRouter } from 'vue-router';
import { checkPathWithin, pathJoin } from '@/helpers/path';

interface Props {
  nodes: NavigationNodeType[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  props: {
    nodes: null
  },
  setup(__props: any) {

const props = __props as {
  nodes: NavigationNodeType[]
}


const router = useRouter();

const childrenRef: Ref<Array<InstanceType<typeof NavigationNode>>> = ref([]);

const renderedNodes = computed<NavigationNodeRender[]>(() => {
  const routePath = router.currentRoute.value.fullPath;
  const proceedNode = (node: NavigationNodeType, pathPrefix?: string): NavigationNodeRender => {
    const fullPath = pathPrefix ? pathJoin(pathPrefix, node.path || '') : (node.path || '');

    let hasActiveChild = false;
    const children: Array<NavigationNodeRender | NavigationButton> = (node.nodes || [] as NavigationNodeType[]).map((child) => {
      if (child.type === NAVIGATION_TYPES.node) {
        const renderedChild = proceedNode(child, fullPath);
        if (renderedChild.isActive) {
          hasActiveChild = true;
        }
        return renderedChild;
      }
      return child;
    });

    return {
      ...node,
      fullPath,
      nodes: children,
      isActive: checkPathWithin(fullPath, routePath, node.exact || false),
    };
  };

  return props.nodes.map((node) => proceedNode(node));
});

router.isReady().then(() => {
  childrenRef.value.forEach((child) => child.openIfActive());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderedNodes), (node) => {
        return (_openBlock(), _createBlock(NavigationNode, {
          ref_for: true,
          ref_key: "childrenRef",
          ref: childrenRef,
          data: node,
          key: node.name
        }, null, 8, ["data"]))
      }), 128))
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})